import { JSX } from 'react';
import {
    Create,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    required,
    AutocompleteInput,
} from 'react-admin';
import { accountTypes, accountStatus } from "../../defaults/defaults";
import { CreateNewCustomerForAccountModal } from "./components/customer-account/CreateNewCustomerForAccountModal";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const CustomerAccountCreate: () => JSX.Element = (): JSX.Element => {

    return (
        <Create redirect="edit">
            <SimpleForm >
                <SelectInput source="type" choices={ accountTypes } defaultValue="personal" validate={ [required()] } />
                <SelectInput source="status" choices={ accountStatus } defaultValue="new" validate={ [required()] } />
                <CreateNewCustomerForAccountModal />
                <ReferenceInput source="accountHolder" reference="customers">
                    <AutocompleteInput label="Account Holder"  />
                </ReferenceInput>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}
